<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="7" :sm="12">
            <el-form-item label="日期范围:">
              <el-date-picker
                v-model="daterange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                class="ele-fluid"
                @change="onDateRangeChoose"
              />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <el-form-item label="教师姓名:">
              <el-input v-model.trim="table.where.teacherName" placeholder="请输入姓名" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询 </el-button>
              <el-button
                @click="
                  (table.where = {
                    startTime: $util.toDateString(new Date(), 'yyyy-MM-dd 00:00:00'),
                    endTime: $util.toDateString(new Date(), 'yyyy-MM-dd 23:59:59'),
                  }) && $refs.table.reload()
                "
                >重置</el-button
              >
              <el-button @click="exportData" type="primary" icon="el-icon-download" class="ele-btn-icon">导出 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column label="教师姓名" prop="teacher_name" align="center" />
          <el-table-column label="手机号" prop="mobile" align="center" />
          <el-table-column label="进出校方向" align="center">
            <template #default="{ row }">
              {{ row.direction == 0 ? '离校' : row.direction == 1 ? '到校' : '未知方向' }}
            </template>
          </el-table-column>
          <el-table-column label="区域" prop="school_area" align="center" />
          <!--          <el-table-column label="设备" align="center">-->
          <!--            <template slot-scope="{row}">-->
          <!--              {{row.slot_type == 1 ? '刷卡话机': row.slot_type == 2 ? '远程化机': row.slot_type == 3 ? '人脸摄像头': row.slot_type == 10 ? '闸机':'未知设备'}}-->
          <!--            </template>-->
          <!--            人脸摄像头-->
          <!--          </el-table-column>-->
          <el-table-column prop="avatar" label="照片" show-overflow-tooltip :fit="true">
            <template #default="{ row }">
              <el-tag :type="row.avatar ? 'success' : 'info'" @click="showImage(row)">{{ row.avatar ? '预览' : '暂无' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="create_time" label="时间" />
        </template>
      </ele-data-table>
    </el-card>
    <!-- 图片预览弹窗 -->
    <el-dialog title="提示" :visible.sync="showteaImage" width="20%" :destroy-on-close="true" :lock-scroll="false" :close-on-click-modal="false">
      <el-image :src="avatar" fit="contain" width="200px" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="showteaImage = false">取 消</el-button>
        <el-button type="primary" @click="showteaImage = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { getAllTeacherClockingListExcel } from '@/config/api';

  export default {
    name: 'StudentRecord',
    data() {
      return {
        table: {
          // 表格配置
          url: '/school/clock/getAllTeacherClockingList',
          where: {
            teacherName:'',
            startTime: this.$util.toDateString(new Date(), 'yyyy-MM-dd 00:00:00'),
            endTime: this.$util.toDateString(new Date(), 'yyyy-MM-dd 23:59:59'),
          },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [], // 表格选中数据
        daterange: [this.$util.toDateString(new Date(), 'yyyy-MM-dd 00:00:00'), this.$util.toDateString(new Date(), 'yyyy-MM-dd 23:59:59')],
        showteaImage: false,
        avatar: null,
      };
    },
    methods: {
      /* 日期选择改变回调 */
      onDateRangeChoose() {
        if (this.daterange) {
          this.table.where.startTime = this.$util.toDateString(this.daterange[0], 'yyyy-MM-dd HH:mm:ss');
          this.table.where.endTime = this.$util.toDateString(this.daterange[1], 'yyyy-MM-dd HH:mm:ss');
        } else {
          this.table.where.startTime = null;
          this.table.where.endTime = null;
        }
      },
      // 导出数据
      exportData() {
        let data = {};
        if (this.daterange) {
          data.startTime = this.$util.toDateString(this.daterange[0], 'yyyy-MM-dd HH:mm:ss');
          data.endTime = this.$util.toDateString(this.daterange[1], 'yyyy-MM-dd HH:mm:ss');
        } else {
          data.startTime = this.$util.toDateString(new Date(), 'yyyy-MM-dd 00:00:00');
          data.endTime = this.$util.toDateString(new Date(), 'yyyy-MM-dd 23:59:59');
        }
        getAllTeacherClockingListExcel(data).then((res) => {
          if (res.data.resCode == 200) {
            window.open(res.data.data);
          } else {
            this.$message({ type: 'info', message: '下载失败' });
          }
        });
      },
      // 预览照片
      showImage(row) {
        if (row.avatar) {
          this.showteaImage = true;
          this.avatar = row.avatar;
        } else {
          return false;
        }
      },
    },
  };
</script>

<style scoped></style>
